export const USER_ACCOUNT_TYPES = {
  STANDARD: 'standard',
  GENIUS: 'genius'
} as const;
